import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CS_BASE_URL } from '../utils/ProjectUrls';
import { CompareResponse } from '../schemas/CompareResponse';

const COMPARE = 'compare';

// 使用createApi创建一个新的API slice
// Use createApi to create a new API slice
export const compareSlice = createApi({
    // 定义这个slice的reducer路径
    // Define the reducer path for this slice
    reducerPath: COMPARE,
    // 设置API请求的基本URL
    // Set the base URL for API requests
    baseQuery: fetchBaseQuery({ baseUrl: CS_BASE_URL }),
    // 定义API endpoints
    // Define the API endpoints
    endpoints: (builder) => ({
        // 定义一个用于获取定义数据的query endpoint
        // Define a query endpoint for fetching definition data
        getCompare: builder.query<CompareResponse, string[]>({
            // fulfill request body
            query: (pns) => ({
                url: `${COMPARE}/${pns.join(',')}/values`,
                method: 'POST',
            }),
        }),
    }),
});

// 从definitionSlice中导出自动生成的hook
// Export the auto-generated hook from the definitionSlice
export const { useGetCompareQuery } = compareSlice;
